// import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   info: {
//     name: "",
//     premiumMember: false,
//     isActive: true,
//     createdAt: null,
//     accountLogoUrl: null,
//     poLogoUrl: null,
//     address: "",
//     taxId: "",
//   },
//   fetchLoading: false,
//   updateLoading: false,
//   deactivateLoading: false,
//   uploadingMainLogo: false,
//   removingMainLogo: false,
//   uploadingPoLogo: false,
//   removingPoLogo: false,
//   error: null,
// };

// const organizationSlice = createSlice({
//   name: "organization",
//   initialState,
//   reducers: {
//     // .................... Fetch ...........................
//     fetchOrgStart(state) {
//       state.fetchLoading = true;
//       state.error = null;
//     },
//     fetchOrgSuccess(state, action) {
//       state.fetchLoading = false;
//       state.info = action.payload;
//     },
//     fetchOrgFailure(state, action) {
//       state.fetchLoading = false;
//       state.error = action.payload;
//     },

//     // .................... Update ...........................
//     updateOrgStart(state) {
//       state.updateLoading = true;
//       state.error = null;
//     },
//     updateOrgSuccess(state, action) {
//       state.updateLoading = false;
//       state.info = { ...state.info, ...action.payload };
//     },
//     updateOrgFailure(state, action) {
//       state.updateLoading = false;
//       state.error = action.payload;
//     },

//     // .................... Deactivate ...........................
//     deactivateOrgStart(state) {
//       state.deactivateLoading = true;
//       state.error = null;
//     },
//     deactivateOrgSuccess(state) {
//       state.deactivateLoading = false;
//       state.info.isActive = false;
//     },
//     deactivateOrgFailure(state, action) {
//       state.deactivateLoading = false;
//       state.error = action.payload;
//     },

//     // .................... Logo busy flags ...........................
//     // Generic setter so upload/remove for either logo shares one reducer
//     // case instead of four near-identical ones.
//     setLogoBusy(state, action) {
//       const { key, value } = action.payload;
//       state[key] = value;
//     },
//   },
// });

// export const {
//   fetchOrgStart,
//   fetchOrgSuccess,
//   fetchOrgFailure,
//   updateOrgStart,
//   updateOrgSuccess,
//   updateOrgFailure,
//   deactivateOrgStart,
//   deactivateOrgSuccess,
//   deactivateOrgFailure,
//   setLogoBusy,
// } = organizationSlice.actions;

// export default organizationSlice.reducer;










import { createSlice } from "@reduxjs/toolkit";
import { revertAll } from "../revertAll/RevertStateReducer";

const initialState = {
  info: null,
  infoLoading: false,
  infoError: null,

  updateLoading: false,
  updateError: null,

  deactivateLoading: false,
  deactivateError: null,

  // Keyed by logo type: "mainLogo" | "poLogo"
  logoUploading: { mainLogo: false, poLogo: false },
  logoUploadError: null,
  logoRemoving: { mainLogo: false, poLogo: false },
  logoRemoveError: null,
};

const organizationSlice = createSlice({
  name: "organization",
  initialState,
  extraReducers: (builder) => builder.addCase(revertAll, () => initialState),
  reducers: {
    fetchOrgStart(state) {
      state.infoLoading = true;
      state.infoError = null;
    },
    fetchOrgSuccess(state, action) {
      state.infoLoading = false;
      state.info = action.payload;
    },
    fetchOrgFailure(state, action) {
      state.infoLoading = false;
      state.infoError = action.payload;
    },

    updateOrgStart(state) {
      state.updateLoading = true;
      state.updateError = null;
    },
    updateOrgSuccess(state) {
      state.updateLoading = false;
    },
    updateOrgFailure(state, action) {
      state.updateLoading = false;
      state.updateError = action.payload;
    },

    deactivateOrgStart(state) {
      state.deactivateLoading = true;
      state.deactivateError = null;
    },
    deactivateOrgSuccess(state) {
      state.deactivateLoading = false;
    },
    deactivateOrgFailure(state, action) {
      state.deactivateLoading = false;
      state.deactivateError = action.payload;
    },

    uploadLogoStart(state, action) {
      state.logoUploading[action.payload] = true;
      state.logoUploadError = null;
    },
    uploadLogoSuccess(state, action) {
      state.logoUploading[action.payload] = false;
    },
    uploadLogoFailure(state, action) {
      state.logoUploading[action.payload.key] = false;
      state.logoUploadError = action.payload.error;
    },

    removeLogoStart(state, action) {
      state.logoRemoving[action.payload] = true;
      state.logoRemoveError = null;
    },
    removeLogoSuccess(state, action) {
      state.logoRemoving[action.payload] = false;
    },
    removeLogoFailure(state, action) {
      state.logoRemoving[action.payload.key] = false;
      state.logoRemoveError = action.payload.error;
    },
  },
});

export const {
  fetchOrgStart,
  fetchOrgSuccess,
  fetchOrgFailure,
  updateOrgStart,
  updateOrgSuccess,
  updateOrgFailure,
  deactivateOrgStart,
  deactivateOrgSuccess,
  deactivateOrgFailure,
  uploadLogoStart,
  uploadLogoSuccess,
  uploadLogoFailure,
  removeLogoStart,
  removeLogoSuccess,
  removeLogoFailure,
} = organizationSlice.actions;

export default organizationSlice.reducer;